import React from "react";
import MainLogo from "./MainLogo";
import MicroIcon from "./MicroIcon";
import { COLORS, TAGLINE, PILLARS } from "./tokens";

/**
 * Amazon Merch on Demand — t-shirt front-print canvas.
 * Exact spec: 4500 × 5400 px, transparent background, sRGB.
 * Design is centered, generous breathing room, no background fill.
 */
export const MerchPrint = React.forwardRef(function MerchPrint(
  { width = 300, id = "pod-merch-print" },
  ref
) {
  const ratio = 5400 / 4500;
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 4500 5400"
      width={width}
      height={width * ratio}
      role="img"
      aria-label="Amazon Merch t-shirt print design"
    >
      {/* NO background fill — Merch requires transparent PNG */}
      <g transform="translate(1000, 400)">
        <MainLogo size={2500} background={true} withRing={true} />
      </g>

      {/* Wordmark + tagline centered below */}
      <g transform="translate(2250, 3420)" textAnchor="middle">
        <text
          textAnchor="middle"
          fontFamily="'Cormorant Garamond', serif"
          fontSize="420"
          fontWeight="500"
          fill={COLORS.brownDeep}
          letterSpacing="8"
        >
          Rona Wellness
        </text>
        <line x1="-400" y1="160" x2="400" y2="160" stroke={COLORS.gold} strokeWidth="3" />
        <text
          textAnchor="middle"
          y="310"
          fontFamily="'Marcellus', serif"
          fontSize="150"
          fill={COLORS.sageDeep}
          letterSpacing="46"
        >
          {PILLARS.toUpperCase()}
        </text>
        <text
          textAnchor="middle"
          y="470"
          fontFamily="'Marcellus', serif"
          fontSize="120"
          fontStyle="italic"
          fill={COLORS.inkSoft}
          letterSpacing="18"
        >
          {TAGLINE}
        </text>
      </g>

      {/* Tiny R-leaf at the bottom */}
      <g transform="translate(2180, 4700)">
        <MicroIcon size={280} color={COLORS.sage} />
      </g>
    </svg>
  );
});

/**
 * Etsy shop icon — 500 × 500 square with circular main logo framed.
 * Amazon-safe, Etsy-safe, Shopify favicon-safe.
 */
export const ShopIcon = React.forwardRef(function ShopIcon(
  { width = 240, id = "pod-shop-icon" },
  ref
) {
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width={width}
      height={width}
      role="img"
      aria-label="Etsy / Shopify shop icon"
    >
      {/* Soft cream background square */}
      <rect width="500" height="500" fill={COLORS.creamSoft} />
      {/* Outer gold ring hint */}
      <circle cx="250" cy="250" r="236" fill="none" stroke={COLORS.gold} strokeOpacity="0.45" strokeWidth="1.5" />
      {/* Main logo centered, slightly smaller so roots breathe */}
      <g transform="translate(20,20)">
        <MainLogo size={460} />
      </g>
    </svg>
  );
});
